export var createPredicate = function createPredicate(type) {
  return function (value) {
    return value.type === type;
  };
};